import * as React from 'react';

import { useSetAtom } from 'jotai';

import { $populateQuoteFormAction } from '../_state/quoteForm.state';
import { QuoteDetailRecord } from '../types/quote';

type Props = {
  quote: QuoteDetailRecord | null | undefined;
};

export const usePopulateQuoteForm = ({ quote }: Props) => {
  const populateForm = useSetAtom($populateQuoteFormAction);

  React.useEffect(() => {
    populateForm(quote);
  }, [quote, populateForm]);
};
